import { render, staticRenderFns } from "./followTerminalAds.vue?vue&type=template&id=00ccbd88&scoped=true"
import script from "./followTerminalAds.vue?vue&type=script&lang=js"
export * from "./followTerminalAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ccbd88",
  null
  
)

export default component.exports